"use strict";
/**
 * @class FieldSet
 * @description implements fieldset with optional legend
 */
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var Messages = require("../../codegen/Messages");
var index_1 = require("../../index");
var Icon_1 = require("../../resources/Icon");
/**
 * OUI field set component.
 * Fieldset that groups other controls together.
 *
 * @oui-component FieldSet
 */
exports.FieldSet = function (_a) {
    var children = _a.children, collapse = _a.collapse, legend = _a.legend, remove = _a.remove, toggle = _a.toggle, tooltip = _a.tooltip, testId = _a.testId;
    var collapseElement;
    var removeElement;
    var toggleElement;
    if (collapse) {
        var collapsed = collapse.collapsed;
        var ariaLabelProp = collapsed ? Messages.Common.expand() : Messages.Common.collapse();
        collapseElement = (React.createElement("span", { className: "oui-margin-small-right oui__fieldset-collapse-control" },
            React.createElement(index_1.Button, { testId: collapse.testId, buttonSize: index_1.ButtonSize.Small, onClick: collapse.onToggle, "aria-expanded": !collapsed },
                React.createElement(index_1.IconElement, { label: ariaLabelProp, ariaLabel: ariaLabelProp, icon: collapsed ? Icon_1.default.Plus : Icon_1.default.Minus, ratio: 0.5 }))));
    }
    if (remove) {
        removeElement = (React.createElement("span", { className: "oui-margin-small-left oui__fieldset-remove-control" },
            React.createElement(index_1.Button, { testId: remove.testId, buttonIcon: remove.icon || Icon_1.default.Close, label: remove.label || Messages.Common.remove(), onClick: remove.onRemove })));
    }
    if (toggle) {
        toggleElement = (React.createElement(index_1.Button, { buttonStyle: index_1.ButtonStyle.MutedLink, onClick: toggle.onToggle }, toggle.toggleText));
    }
    var tooltipElement = tooltip && (React.createElement(React.Fragment, null,
        React.createElement(index_1.Button, { type: index_1.ButtonType.Button, buttonStyle: index_1.ButtonStyle.Link },
            React.createElement(index_1.IconElement, { label: "info", ariaLabel: "info", className: "oui-legend__tooltip-icon", icon: Icon_1.default.Info })),
        React.createElement(index_1.Tooltip, null, tooltip)));
    var legendElement = (legend || collapse || remove) && (React.createElement("div", { className: "oui-legend-wrapper oui-flex oui-flex-between oui-flex-top" },
        React.createElement("div", { className: "oui-flex oui-flex-top oui-flex-left" },
            collapseElement,
            React.createElement("legend", null, legend),
            tooltipElement),
        (remove || toggle) && (React.createElement("div", { className: "oui-margin-left oui-flex oui-flex-top oui-flex-" },
            toggleElement,
            removeElement))));
    return (React.createElement("fieldset", { className: classNames("oui-fieldset-default oui__fieldset", {
            "oui-collapsed": collapse && collapse.collapsed && !collapse.showChildrenWhenCollapsed
        }), "data-test-id": testId },
        legendElement,
        React.createElement("div", { role: "group", className: classNames("oui__fieldset-content", {
                "oui-hidden": collapse &&
                    collapse.collapsed &&
                    !collapse.showChildrenWhenCollapsed
            }) }, children)));
};
//# sourceMappingURL=FieldSet.js.map